import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"




export const updateProgress = ids => get(url.UPDATE_PROGRESS + ids);
export const getStudentProgress = ids => get(url.GET_STUDENT_PROGRESS + ids);

export const submitAssessmentForStudent = ids => get(url.SUBMIT_ASSESSMENT_FOR_STUDENT + ids);